/**
 * Volume-tier pricing: the tier whose upTo covers the total quantity
 * (baseQty + extraQty) applies its price per unit to the extra units only.
 * This correctly accounts for quantity already included in the base plan,
 * so users benefit from volume discounts on their incremental additions.
 * The last tier with upTo=null acts as the "∞" tier.
 */
export function calcTieredCost(
    extraQty: number,
    tiers: { upTo?: number | null; price: number }[],
    baseQty = 0,
): number {
    if (extraQty <= 0 || tiers.length === 0) return 0;
    const sorted = [...tiers].sort((a, b) =>
        a.upTo == null ? 1 : b.upTo == null ? -1 : (a.upTo ?? 0) - (b.upTo ?? 0),
    );
    const totalQty = baseQty + extraQty;
    for (const tier of sorted) {
        if (tier.upTo == null || totalQty <= tier.upTo) {
            return extraQty * tier.price;
        }
    }
    // Fallback: last tier
    return extraQty * sorted[sorted.length - 1].price;
}
